import React from 'react';
import { FaMapMarkerAlt, FaUsers, FaAward, FaHandshake } from 'react-icons/fa';
import { COMPANY_STORY, COMPANY_VALUES, SERVICE_AREAS, COMPANY_CONTACT } from '../config/company';
import './About.css';

const About = () => {
  const values = [
    {
      icon: <FaHandshake />,
      title: COMPANY_VALUES[0].title,
      description: COMPANY_VALUES[0].description
    },
    {
      icon: <FaAward />,
      title: COMPANY_VALUES[1].title,
      description: COMPANY_VALUES[1].description
    },
    {
      icon: <FaMapMarkerAlt />,
      title: COMPANY_VALUES[2].title,
      description: COMPANY_VALUES[2].description
    },
    {
      icon: <FaUsers />,
      title: COMPANY_VALUES[3].title,
      description: COMPANY_VALUES[3].description
    }
  ];

  return (
    <div className="about-page">
      <div className="container">
        {/* Header */}
        <div className="about-header">
          <div className="about-header-content">
            <h1 className="page-title">About Bama Billboards</h1>
            <p className="page-subtitle">
              Calhoun County's premier outdoor advertising company, dedicated to helping local businesses grow through strategic billboard placement.
            </p>
          </div>
        </div>

        {/* Story Section */}
        <section className="section story-section">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              <p>{COMPANY_STORY.founded}</p>
              <p>{COMPANY_STORY.mission}</p>
              <p>{COMPANY_STORY.current}</p>
              <p>{COMPANY_STORY.commitment}</p>
            </div>
            <div className="story-image">
              <div className="image-placeholder">
                <FaMapMarkerAlt />
                <p>Calhoun County, Alabama</p>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="section values-section">
          <h2 className="section-title">Our Values</h2>
          <p className="section-subtitle">
            These core values guide everything we do and ensure we provide the best service to our customers.
          </p>
          
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">
                  {value.icon}
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Service Areas */}
        <section className="section areas-section">
          <h2 className="section-title">Service Areas</h2>
          <p className="section-subtitle">
            We proudly serve the following cities in Calhoun County, Alabama
          </p>
          
          <div className="areas-grid">
            <div className="area-card">
              <h3>{SERVICE_AREAS[0]}</h3>
              <p>The county seat and largest city, offering high-traffic locations on major highways and downtown areas.</p>
            </div>
            <div className="area-card">
              <h3>{SERVICE_AREAS[1]}</h3>
              <p>Strategic locations near I-20 and major retail areas for maximum exposure to shoppers and commuters.</p>
            </div>
            <div className="area-card">
              <h3>{SERVICE_AREAS[2]}</h3>
              <p>Local community billboards perfect for reaching residents and businesses in this growing area.</p>
            </div>
            <div className="area-card">
              <h3>{SERVICE_AREAS[3]}</h3>
              <p>Premium locations near the famous Talladega Superspeedway and major highways.</p>
            </div>
            <div className="area-card">
              <h3>{SERVICE_AREAS[4]}</h3>
              <p>High-visibility locations on US-78 for reaching commuters and local residents.</p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="section cta-section">
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>
              Join hundreds of satisfied customers who trust Bama Billboards for their outdoor advertising needs. 
              Contact us today for a free consultation and competitive quote.
            </p>
            <div className="cta-buttons">
                          <a href={`tel:${COMPANY_CONTACT.phoneLink}`} className="btn btn-primary">
              Call {COMPANY_CONTACT.phone}
            </a>
            <a href={`mailto:${COMPANY_CONTACT.email}`} className="btn btn-secondary">
              Email Us
            </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About; 